import { STATES } from '@upstart/harmony/lib/legos/constants/index.js';

export const missingTextPlaceholder = '-';

export const STATE_OPTIONS = Object.keys(STATES);
